import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaxmimizeDirective } from './directives/maxmimize.directive';
import { FileDropDirective } from './directives/file-drop.directive';

@NgModule({
  declarations: [MaxmimizeDirective, FileDropDirective],
  imports: [CommonModule],
  exports: [MaxmimizeDirective, FileDropDirective],
})
export class DirectiveModule {}
